import React from "react";
import "./AdminDashboard.css";
import "./Topbar.css";

const Topbar = ({ onMenuClick }) => {
  const fullName = localStorage.getItem("name") || "";
  const firstName = fullName.split(" ")[0];

  return (
    <div className="admin-topbar">
      <button className="menu-btn-admin-dashboard" onClick={onMenuClick}>
        ☰
      </button>

      <div className="welcome-admin">Welcome, {firstName || "Admin"}</div>

      <button
        className="logout-btn"
        onClick={() => {
          localStorage.clear();
          window.location.href = "/login";
        }}
      >
        Logout
      </button>
    </div>
  );
};

export default Topbar;
